export default __webpack_public_path__ + "static/media/truckRojevas.e0b808f3.jpg";